function loadImageToTexture(url) {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
        image.onload = () => {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = image.width;
            canvas.height = image.height;
            ctx.drawImage(image,0,0);
            resolve({
                width: image.width,
                height: image.height,
                texture: new THREE.TextureLoader().load(canvas.toDataURL())
            });
        };
    })
}
export default loadImageToTexture;